import { MOCK_CATALOG } from "@/mocks/data/catalog";
import type { OtpVerifiedUserWire } from "@/mocks/types";

export const MOCK_OTP_CODE = "123456";

export const createOtpVerifiedUser = (shopifyOrigin: string): OtpVerifiedUserWire => {
  return {
    hasCbdOnly: false,
    hasThcProduct: true,
    products: [
      { product: MOCK_CATALOG.RAPID_RELIEF, productType: "inhaler" },
      { product: MOCK_CATALOG.CALM_DAY, productType: "gummy_edible" },
    ].map(({ product, productType }) => {
      return {
        sku: product.sku,
        name: product.name,
        url: `${shopifyOrigin}/products/${product.handle}`,
        productType,
        thcCbdType: "Full spectrum",
        doses: [
          { id: "1", key: "low", value: "1 serving" },
          { id: "2", key: "medium", value: "2 servings" },
        ],
        sideEffects: ["Dizziness", "Dry mouth", "Too intoxicated (effects too strong)"],
      };
    }),
    verified: true,
  };
};
